export const getLeftDrawerRootClassName = (hasBanner: boolean) =>
  hasBanner
    ? "sticky top-0 z-[60] mt-[var(--banner-stack-height)] h-[calc(100vh-var(--banner-stack-height))]"
    : "sticky top-0 z-[60] h-screen";
